/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';

import Vue from "vue";
import VueRouter from "vue-router";
import VueTagManager from "vue-tag-manager";
import VueSweetalert2 from "vue-sweetalert2";
import Toast from "vue-toastification";
import VueI18n from "vue-i18n";
import vuetify from "../plugins/vuetify";
import languages from "../lang/languages.js";
import VueHotkey from 'v-hotkey'
import 'virtual:uno.css'
import "vue-toastification/dist/index.css";
import 'sweetalert2/src/sweetalert2.scss';
import 'sweetalert2/src/sweetalert2';
import '@fortawesome/fontawesome-free/css/all.css'
// Import Sortable.js before vuedraggable
import Sortable from 'sortablejs';
window.Sortable = Sortable;

// Import Vuetify components
import { 
    VCombobox, 
    VSelect, 
    VTextField, 
    VDataTable, 
    VBtn, 
    VIcon, 
    VProgressLinear, 
    VOverlay, 
    VCard, 
    VProgressCircular, 
    VDialog,
    VSpacer,
    VDivider,
    VCardText,
    VCardActions,
    VRow, 
    VCol,
    VToolbar,
    VToolbarTitle,
    VChip
} from 'vuetify/lib'
Vue.component('v-combobox', VCombobox)
Vue.component('v-select', VSelect)
Vue.component('v-text-field', VTextField)
Vue.component('v-data-table', VDataTable)
Vue.component('v-btn', VBtn)
Vue.component('v-icon', VIcon)
Vue.component('v-progress-linear', VProgressLinear)
Vue.component('v-overlay', VOverlay)
Vue.component('v-card', VCard)
Vue.component('v-progress-circular', VProgressCircular)
Vue.component('v-dialog', VDialog)
Vue.component('v-spacer', VSpacer)
Vue.component('v-divider', VDivider)
Vue.component('v-card-text', VCardText)
Vue.component('v-card-actions', VCardActions)
Vue.component('v-row', VRow)
Vue.component('v-col', VCol)
Vue.component('v-toolbar', VToolbar)
Vue.component('v-toolbar-title', VToolbarTitle)
Vue.component('v-chip', VChip)


// Import all components first
import StripeCheckout from "../views/admin/stripe/checkout/checkout.vue";
import StripeCancel from "../views/admin/stripe/cancel/cancel.vue";
import StripeDashboard from "../views/admin/stripe/dashboard/dashboard.vue";
import DashBoard from "../views/admin/dashboard/DashBoard.vue";
import CustomNotify from "../views/layouts/CustomNotify.vue";
import PripomenutieKlient from "../views/emails/PripomenutieKlient.vue";
import AuthLogin from "../views/auth/components/login.vue";
import OffersTable from "../views/admin/offer/OffersTable.vue";
import OfferMain from "../views/admin/offer/OfferMain.vue";
import AiOfferModal from "../views/admin/offer/components/AiOfferModal.vue";
import AiAssistant from "../views/admin/offer/components/AiAssistant.vue";
import FirstLogin from "../views/admin/settings/first_login/FirstLogin.vue";
import FirmaKontakty from "../views/admin/settings/firma_a_kontakty/FirmaKontakty.vue";
import MainUcet from "../views/admin/settings/ucet/MainUcet.vue";
import MainNotifikacie from "../views/admin/settings/notifikacie/MainNotifikacie.vue";
import MainIntegracie from "../views/admin/settings/integracie/MainIntegracie.vue";
import BlogArticle from "../views/sub/blog/BlogArticle.vue";
import BlogMain from "../views/sub/blog/BlogMain.vue";
import BlogTable from "../views/admin/admin_page/blog/BlogTable.vue";
import Impersonating from "../views/admin/admin_page/impersonating/impersonating.vue";
import SubscriptionHistory from "../views/admin/admin_page/subscriptions/history/subscriptionHistory.vue";
import ChangeLog from "../views/admin/changelog/ChangeLog.vue";
import ChangelogAlert from "../views/admin/vue_components/ChangelogAlert.vue";
import FeedBack from "../views/admin/feedback/FeedBack.vue";
import CompanyUsers from "../views/admin/premium/company_users/CompanyUsers.vue";
import CustomColor from "../views/admin/premium/custom_color/CustomColor.vue";
import TheReviews from "../views/admin/premium/reviews/TheReviews.vue";
import MojeFirmy from "../views/admin/premium/moje_firmy/MojeFirmy.vue";
import Items from "../views/admin/premium/items/items.vue";
import TableCompanies from "../views/admin/admin_page/companies/TableCompanies.vue";
import TableUsers from "../views/admin/admin_page/users/TableUsers.vue";
import AdminStatistics from "../views/admin/admin_page/statistics/AdminStatistics.vue";
import MenuLeft from "../views/layouts/LeftSide/MenuLeft.vue";
import MenuLeftMobile from "../views/layouts/LeftSide/MenuLeftMobile.vue";
import TopBar from "../views/layouts/Header/TopBar.vue";
import TopBarMobile from "../views/layouts/Header/TopBarMobile.vue";
import UnderBarName from "../views/layouts/Header/UnderBarName.vue";
import PrijatPonuku from "../views/price/components/PrijatPonuku.vue";
import OdmietnutPonuku from "../views/price/components/OdmietnutPonuku.vue";
import PriceReviews from "../views/price/components/PriceReviews.vue";
import CardDescription from "../views/price/components/CardDescription.vue";
import EntryImagePrice from "../views/price/components/EntryImagePrice.vue";
import FilesToDownload from "../views/price/components/FilesToDownload.vue";
import CheckIpAddress from "../views/price/components/CheckIpAddress.vue";
import KlientsTable from "../views/admin/klient/KlientsTable.vue";
import KlientCreate from "../views/admin/klient/components/KlientCreate.vue";
import PremiumPackages from "../views/sub/components/PremiumPackages.vue";
import CennikTable from "../views/sub/components/CennikTable.vue";
import MainStatistics from "../views/admin/statistics/MainStatistics.vue";
import PretlakRegister from "../views/sub/components/pretlak/PretlakRegister.vue";
import DigiRegister from "../views/sub/components/digitalna-univerzita/DigiRegister.vue";
import Auvid from "../views/price/users_templates/auvid/Auvid.vue";
import Alert from "../views/admin/admin_page/alerts/Alert.vue";
import GlobalAlert from "../views/admin/admin_page/alerts/GlobalAlert.vue";
import AdminInvoices from "../views/admin/admin_page/invoices/AdminInvoices.vue";
import MissingInvoices from "../views/admin/admin_page/missing_invoices/MissingInvoices.vue";
import MaxOfferModal from "../views/admin/offer/OfferTable_components/MaxOfferModal.vue";
import MaxOfferClient from '../views/layouts/Header/MaxOfferClient.vue';
import DofferoPriceTable from "../views/sub/components/DofferoPriceTable.vue";
import DofferoPriceTableCompare from "../views/sub/components/DofferoPriceTableCompare.vue";
import StripePricePlan from '../views/admin/stripe/dashboard/components/PricePlan.vue'
import AuthRegister from '../views/auth/components/register.vue'
import DigiUniApp from '../views/sub/components/DigiuniApp.vue'
import PaidModal from '../views/admin/vue_components/PaidModal.vue'
// Initialize Vue and its plugins
Vue.use(VueRouter);
Vue.use(Toast);
Vue.use(VueI18n);
Vue.use(VueSweetalert2);
Vue.use(VueHotkey)

import { installCurrency } from "./currency";
installCurrency(Vue);

// Register all components
Vue.component("stripe-checkout", StripeCheckout);
Vue.component("stripe-price-plan", StripePricePlan);
Vue.component("stripe-cancel", StripeCancel);
Vue.component("stripe-dashboard", StripeDashboard);
Vue.component("dash-board", DashBoard);
Vue.component("custom-notify", CustomNotify);
Vue.component("pripomenutie-klient", PripomenutieKlient);
Vue.component("auth-login", AuthLogin);
Vue.component("auth-register", AuthRegister);
Vue.component("offers-table", OffersTable);
Vue.component("offer-main", OfferMain);
Vue.component("ai-offer-modal", AiOfferModal);
Vue.component("ai-assistant", AiAssistant);
Vue.component("first-login", FirstLogin);
Vue.component("firma-kontakty", FirmaKontakty);
Vue.component("main-ucet", MainUcet);
Vue.component("main-notifikacie", MainNotifikacie);
Vue.component("main-integracie", MainIntegracie);
Vue.component("blog-article", BlogArticle);
Vue.component("blog-main", BlogMain);
Vue.component("blog-table", BlogTable);
Vue.component("impersonating", Impersonating);
Vue.component("subscription-history", SubscriptionHistory);
Vue.component("change-log", ChangeLog);
Vue.component("changelog-alert", ChangelogAlert);
Vue.component("feed-back", FeedBack);
Vue.component("company-users", CompanyUsers);
Vue.component("custom-color", CustomColor);
Vue.component("reviews", TheReviews);
Vue.component("moje-firmy", MojeFirmy);
Vue.component("items", Items);
Vue.component("companies-table", TableCompanies);
Vue.component("table-users", TableUsers);
Vue.component("admin-statistics", AdminStatistics);
Vue.component("menu-left", MenuLeft);
Vue.component("menu-left-mobile", MenuLeftMobile);
Vue.component("top-bar", TopBar);
Vue.component("top-bar-mobile", TopBarMobile);
Vue.component("under-bar-name", UnderBarName);
Vue.component("prijat-ponuku", PrijatPonuku);
Vue.component("odmietnut-ponuku", OdmietnutPonuku);
Vue.component("price-reviews", PriceReviews);
Vue.component("card-description", CardDescription);
Vue.component("entry-image-price", EntryImagePrice);
Vue.component("files-to-download", FilesToDownload);
Vue.component("check-ip-address", CheckIpAddress);
Vue.component("klients-table", KlientsTable);
Vue.component("klient-create", KlientCreate);
Vue.component("premium-packages", PremiumPackages);
Vue.component("cennik-table", CennikTable);
Vue.component("main-statistics", MainStatistics);
Vue.component("pretlak-register", PretlakRegister);
Vue.component("digi-register", DigiRegister);
Vue.component("auvid", Auvid);
Vue.component("alert", Alert);
Vue.component("global-alert", GlobalAlert);
Vue.component("admin-invoices", AdminInvoices);
Vue.component("missing-invoices", MissingInvoices);
Vue.component("max-offer-modal", MaxOfferModal);
Vue.component("max-offer-client", MaxOfferClient);
Vue.component("doffero-price-table", DofferoPriceTable);
Vue.component("doffero-price-table-compare", DofferoPriceTableCompare);
Vue.component("digiuni-app", DigiUniApp);
Vue.component("paid-modal", PaidModal);
// Define routes
const routes = [
    { path: '/registracia', component: () => import('../views/auth/components/register.vue') }
];

// Initialize router
const router = new VueRouter({
    mode: 'history',
    routes
});

// Initialize i18n
const i18n = new VueI18n({
    locale: document.documentElement.lang || 'sk',
    fallbackLocale: 'sk',
    messages: languages,
});


// Initialize GTM if needed
if ($("body").attr("data-gtm") != "ponuka") {
    Vue.use(VueTagManager, {
        gtmId: "GTM-5STG6LR",
    });
}

// Vue directives
Vue.directive("click-outside-filter", {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            if (!(el === event.target || el.contains(event.target))) {
                if (
                    !event.target.closest(".offer_status_btn") &&
                    !event.target.closest(".offer_status_box")
                ) {
                    vnode.context[binding.expression](event);
                }
            }
        };
        setTimeout(() => {
            document.addEventListener("click", el.clickOutsideEvent);
        }, 0);
    },
    unbind: function (el) {
        document.removeEventListener("click", el.clickOutsideEvent);
    },
});

Vue.config.devtools = true;

// Create Vue instance
const app = new Vue({
    i18n,
    vuetify,
    el: "#pcoded",
    router,
});

// Initialize Lang plugin after Vue instance
Vue.use( {
    i18n,
    locale: document.documentElement.lang || 'sk',
    fallback: 'sk',
    translations: languages,
    context: () => app.$i18n
});

// Initialize secondary Vue instance if needed
var myEle = document.getElementById("pretlak");
if (myEle) {
    new Vue({
        el: "#pretlak",
    });
}

// var dofferoPriceTable = document.getElementById("doffero-price-table");
// if(dofferoPriceTable){
//     new Vue({
//         el: "#doffero-price-table",
//     });
// }
// var dofferoPriceTableCompare = document.getElementById("doffero-price-table-compare");
// if(dofferoPriceTableCompare){
//     new Vue({
//         el: "#doffero-price-table-compare",
//     });
// }

// Google DataLayer
$(".datalayer_menu").on("click", function () {
    Vue.gtm.push({
        event: "button",
        "Event category": "button",
        "Event action": "click",
        "Event label": "menu",
    });
});

$(".datalayer_header").on("click", function () {
    Vue.gtm.push({
        event: "button",
        "Event category": "button",
        "Event action": "click",
        "Event label": "header",
    });
});